import cx from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import * as Collapsible from "@radix-ui/react-collapsible";
import IconChevron from "../../../assets/icons/IconChevron";
import * as styles from "./TransitLegFooter.module.css";
const TransitLegFooter = ({ labelMessage = "", icon, content }) => /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.transitLegFooter)
}, /* @__PURE__ */ React.createElement(Collapsible.Root, null, /* @__PURE__ */ React.createElement(Collapsible.Trigger, {
  asChild: true
}, /* @__PURE__ */ React.createElement("button", {
  type: "button",
  className: styles.collapseTrigger
}, /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.footerLabel)
}, icon, /* @__PURE__ */ React.createElement(FormattedMessage, {
  id: labelMessage
})), /* @__PURE__ */ React.createElement("div", {
  className: styles.collapseIcon
}, /* @__PURE__ */ React.createElement(IconChevron, {
  className: styles.chevron
})))), /* @__PURE__ */ React.createElement(Collapsible.Content, {
  className: styles.passengerList
}, content)));
var TransitLegFooter_default = TransitLegFooter;
export {
  TransitLegFooter_default as default
};
